export default __webpack_public_path__ + "static/holiday-225e94a02958eae644812be3bfabc5ce.png";